<template>
    <NavBar color="#343A41" bgcolor="white">
        <template v-slot:title>
            <span class="nav-title">活动专区</span>
        </template>
    </NavBar>
    <div class="main" v-if="activities.length">
        <router-link :to="'/activity/' + activity.id" v-for="activity in activities" :key="activity.id" class="item">
            <img :src="activity.cover">
        </router-link>
    </div>
    <div v-show="! loading && activities.length <= 0" class="list-null">
        <van-empty
            :image="require('@/assets/images/kong.png')"
            description="暂无活动"
        />
    </div>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>